import { supabase } from '@/lib/supabase'
import { SAMPLE_TESTIMONIALS } from '../sample'

export type Testimonial = {
  id: string
  author_name: string
  author_handle?: string | null
  avatar_url?: string | null
  text: string
  href?: string | null
  visible?: boolean | null
  position?: number | null
  created_at?: string
}

export async function listPublicTestimonials(limit = 20): Promise<Testimonial[]> {
  try {
    const { data, error } = await supabase
      .from('testimonials')
      .select('id, author_name, author_handle, avatar_url, text, href, position')
      .eq('visible', true)
      .order('position', { ascending: true, nullsFirst: false })
      .order('created_at', { ascending: true })
      .limit(limit)
    if (error) throw error
    return (data as any[]) as Testimonial[]
  } catch (e: any) {
    if (String(e?.message || '').includes('schema cache') || String(e?.message || '').includes('42P01')) {
      return SAMPLE_TESTIMONIALS.slice(0, limit)
    }
    throw e
  }
}

export async function listAllTestimonials(): Promise<Testimonial[]> {
  try {
    const { data, error } = await supabase
      .from('testimonials')
      .select('*')
      .order('position', { ascending: true, nullsFirst: false })
      .order('created_at', { ascending: true })
    if (error) throw error
    return (data as any[]) as Testimonial[]
  } catch (e: any) {
    if (String(e?.message || '').includes('schema cache') || String(e?.message || '').includes('42P01')) {
      return SAMPLE_TESTIMONIALS
    }
    throw e
  }
}

function isUuid(v?: string | null): boolean {
  if (!v) return false
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(v)
}

export async function upsertTestimonial(payload: Partial<Testimonial> & { text: string; author_name: string }): Promise<{ id: string }>{
  const body: any = { ...payload }
  if (!isUuid(body.id)) delete body.id
  if (typeof body.visible !== 'boolean') body.visible = true
  const { data, error } = await supabase.from('testimonials').upsert(body, { onConflict: 'id' }).select('id').single()
  if (error) throw error
  return { id: (data as any).id as string }
}

export async function deleteTestimonial(id: string): Promise<void> {
  const { error } = await supabase.from('testimonials').delete().eq('id', id)
  if (error) throw error
}
